module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "other-login-title"
  }, [_vm._v("贝壳系统号登录 "), _c('i', {
    staticClass: "icon-close",
    on: {
      "click": _vm.handleClose
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "login-label"
  }, [_vm._v("系统号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.ljCode),
      expression: "ljCode",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-item-base login-input disable_num_arrow",
    class: {
      'login-input--hasval': _vm.ljCode
    },
    attrs: {
      "type": "text",
      "maxlength": 20,
      "placeholder": "请输入系统号"
    },
    domProps: {
      "value": (_vm.ljCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ljCode = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "login-label u-mt16"
  }, [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-item-base login-input",
    class: {
      'login-input--hasval': _vm.password
    },
    attrs: {
      "type": "password",
      "maxlength": "30",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doLogin.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.needInputCaptcha) ? _c('div', [_c('p', {
    staticClass: "login-label u-mt16"
  }, [_vm._v("图形验证码")]), _vm._v(" "), _c('div', {
    staticClass: "login-captcha-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.captcha),
      expression: "captcha",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-item-base login-input",
    class: {
      'login-input--hasval': _vm.captcha
    },
    attrs: {
      "type": "text",
      "maxlength": 6,
      "placeholder": "请输入图形验证码"
    },
    domProps: {
      "value": (_vm.captcha)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doLogin.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captcha = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "login-captcha",
    attrs: {
      "src": _vm.captchaObj ? 'data:image/jpeg;base64,' + _vm.captchaObj.base64Data : ''
    },
    on: {
      "click": function($event) {
        return _vm.changeCaptcha($event)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.validateMag && _vm.validateCode != _vm.MOBILE_PWD_FAIL_TOOMANY_TIMES) ? _c('p', {
    staticClass: "login-errmsg-container"
  }, [_c('span', {
    staticClass: "login-errmsg"
  }, [_vm._v("\n            " + _vm._s(_vm.validateMag) + "，请前往 "), _c('a', {
    staticClass: "text-main",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.navToMobileLogin
    }
  }, [_vm._v("快捷登录")])])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "form-item-base login-btn u-mt16",
    class: {
      'login-btn--active': !_vm.disabledLoginBtn
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.doLogin
    }
  }, [(_vm.isSubmitting) ? _c('span', [_vm._v("登录中...")]) : _c('span', [_vm._v("登录")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bf88e6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/resources/static/js/component/EmpNoLogin.vue
// module id = 410
// module chunks = 3